export default "__VITE_ASSET__DnvOgVK___"